(() => {
  if (customElements.get('product-upsell-express')) return;
  class ProductUpsellExpress extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.scope = this.form?.closest('.shopify-section, dialog, product-card') || this.form;
      this.scheduleSync = () => {
        if (this.syncQueued) return;
        this.syncQueued = true;
        queueMicrotask(() => { this.syncQueued = false; if (this.isConnected) this.sync(); });
      };
      this.onClick = event => {
        if (!this.querySelector('[data-product-wallet]')?.contains(event.target)) return;
        if (!this.sync()) { event.preventDefault(); event.stopImmediatePropagation(); }
      };
      this.onProductSelect = event => {
        const sourceCard = event.target?.closest?.('product-card');
        if (sourceCard && !sourceCard.contains(this)) return;
        if (!this.scope?.contains(event.target) || !event.promise?.then) return;
        const pending = this.variantPromise = event.promise;
        this.variantError = false;
        this.sync();
        pending.then(result => {
          if (this.variantPromise !== pending) return;
          this.variantError = result?.detail?.resource == null || result.detail.resource.available === false;
          this.variantPromise = null; this.scheduleSync();
        }, () => {
          if (this.variantPromise !== pending) return;
          this.variantPromise = null; this.variantError = true; this.scheduleSync();
        });
      };
      this.addEventListener('click', this.onClick, true);
      this.scope?.addEventListener('change', this.scheduleSync);
      this.scope?.addEventListener('input', this.scheduleSync);
      this.scope?.addEventListener('shopify:product:select', this.onProductSelect);
      document.addEventListener('cart:updated', this.scheduleSync);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.scheduleSync();
      });
      this.observer.observe(document.body, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['value', 'disabled', 'hidden', 'data-id', 'data-selected', 'data-default-selected', 'data-variant-available', 'data-selection-config-changed'],
      });
      customElements.whenDefined('cart-drawer').then(() => { if (this.isConnected) this.sync(); });
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick, true);
      this.scope?.removeEventListener('change', this.scheduleSync);
      this.scope?.removeEventListener('input', this.scheduleSync);
      this.scope?.removeEventListener('shopify:product:select', this.onProductSelect);
      document.removeEventListener('cart:updated', this.scheduleSync);
      this.variantPromise = null;
    }

    sync() {
      const wallet = this.querySelector('[data-product-wallet]');
      const fields = this.querySelector('[data-express-fields]');
      const status = this.querySelector('[data-product-express-status]');
      if (!wallet || !fields || !status) return false;
      try {
        if (!window.GeneralStoreRuntime?.purchaseAddons || this.variantPromise) throw new Error('Preparing express checkout…');
        const mainInput = this.form?.querySelector('[name="id"]:not(:disabled)');
        const mainId = mainInput?.value;
        if (this.variantError || !/^[1-9]\d*$/.test(mainId || '') || this.closest('.accelerated-checkout-block[hidden]')
          || this.form?.querySelector('[name="add"]')?.disabled) throw new Error('Select an available product option.');
        const quantity = Number([...this.form.elements].find(input => input.name === 'quantity' && !input.disabled)?.value || 1);
        if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Enter a valid quantity.');
        const items = window.GeneralStoreRuntime.purchaseAddons(this.form, mainId);
        const values = [];
        items.forEach((item, index) => {
          const prefix = `shopify-additional-items[${index + 1}]`;
          values.push([`${prefix}[id]`, item.id], [`${prefix}[quantity]`, String(item.quantity)], [`${prefix}[parent_id]`, mainId]);
          values.push([`${prefix}[properties]`, JSON.stringify(Object.entries(item.properties).map(([key, value]) => ({ key, value: String(value) })))]);
          if (item.selling_plan) values.push([`${prefix}[selling_plan]`, item.selling_plan]);
        });
        const current = [...fields.querySelectorAll('input')].map(input => [input.name, input.value]);
        if (JSON.stringify(current) !== JSON.stringify(values)) {
          const fragment = document.createDocumentFragment();
          for (const [name, value] of values) {
            const input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.value = value;
            input.dataset.expressAdditionalItem = 'true'; fragment.append(input);
          }
          fields.replaceChildren(fragment);
        }
        status.textContent = ''; status.hidden = true;
        wallet.inert = false;
        return true;
      } catch (error) {
        wallet.inert = true;
        if (fields.childNodes.length) fields.replaceChildren();
        status.hidden = false;
        if (status.textContent !== error.message) status.textContent = error.message;
        return false;
      }
    }
  }
  customElements.define('product-upsell-express', ProductUpsellExpress);
})();
